import React, { useState, useEffect, Fragment } from 'react'
import {t} from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Row, Button, Collapse, Col, Card, CardBody, CardFooter } from 'reactstrap'
import { useRecoilState } from 'recoil'
import axios from 'axios'
import { Accordion } from 'react-bootstrap';

import env from '../../../env/src_config'
import { headersState } from '../../../recoil/recoil';
import Spinner from '../../spinner/Spinner'
import PaginationTop from '../../Pagination/PaginationTop'
import PaginationBottom from '../../Pagination/PaginationBottom'
import { axiosError } from '../../../helpers/response'
import { isNull } from '../../../izUtils'
import { transformer } from '../../../helpers/fields'
import ManufacturerList from './lists/ManufacturerList'
import AddUpdateManufacturer from './AddUpdateManufacturer'
import Systems from '../systems/Systems'
import Filter from '../../filters/Filter'

const Manufacturers = () => {
    const Navigate = useNavigate();
    const [headers] = useRecoilState(headersState);
    const { securitySystemId, manufacturerId } = useParams();

    const [isOpen, setIsOpen] = useState(null);
    const [manufacturers, setManufacturers] = useState(null)
    const [filters, setFilters] = useState(null)

    const lsFilterName = 'AKODA.manufacturerFilter';

    useEffect(() => {
        getManufacturers({ security_system: {value: securitySystemId} });

        return () => {
            localStorage.removeItem(lsFilterName)
        }
    }, [securitySystemId]) // eslint-disable-line react-hooks/exhaustive-deps

    const getManufacturers = (passedFilters) => {
        const keys = Object.keys(passedFilters);
        let payload = { filters: {} };
        for (let i = 0; i < keys.length; i++) {
            if (!isNull(passedFilters[keys[i]].value) && passedFilters[keys[i]].value.length !== 0) {
                payload.filters[keys[i]] = passedFilters[keys[i]].value;
            } else {
                payload.filters[keys[i]] = "";
            }
        }
        
        axios.post(env.api + '/api/security_system/manufacturer/list', payload, {headers}).then(response => {
            if (!isNull(response.data.data)) {
                setManufacturers(response.data.data);
                if (!isNull(response.data.filters)) {
                    setFilters(transformer(response.data.filters));
                    localStorage.setItem(lsFilterName, JSON.stringify(transformer(response.data.filters)))
                }
            }
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }

    const clearData = () => {
        localStorage.removeItem(lsFilterName);
        getManufacturers({ security_system: {value: securitySystemId} });
    }

    if (isNull(manufacturers)) {
        return <Spinner />
    } else {
        const filterFields = [/*'security_system',*/ 'title']
        return (
            <Fragment>
                <Row>
                    <Col md="6">
                        <Card className="ribbon-wrapper">
                            <CardBody>
                                <div className="ribbon ribbon-clip ribbon-primary">{t('securitySystems.manufacturers.list.title')}</div>
                                <div>
                                    <Accordion className='mb-3'>
                                        <div className="default-according style-1" id="manufacturerFilter">
                                            <Button color="secondary" className="acc-btn d-flex justify-content-between align-items-center" data-toggle="collapse" onClick={() => setIsOpen(!isOpen)}>
                                                {t('filters')}
                                                <div className={'filter-icon' + (isOpen ? ' rotate-icon' : '')}>
                                                    <i className="fa fa-chevron-down"></i>
                                                </div>
                                            </Button>
                                            <Collapse isOpen={isOpen}>
                                                <div className='p-3'>
                                                    <Filter filterFields={filterFields} filters={filters} getData={(clonedFilters) => getManufacturers(clonedFilters)} lsFilterName={lsFilterName} clearData={clearData} />
                                                </div>
                                            </Collapse>
                                        </div>
                                    </Accordion>
                                    <PaginationTop filters={filters} getData={clonedFilters => getManufacturers(clonedFilters)} />
                                    <ManufacturerList data={manufacturers}/>
                                    <PaginationBottom filters={filters} getData={clonedFilters => getManufacturers(clonedFilters)} />
                                </div>

                            </CardBody>
                            <CardFooter>
                                <div className='text-start'>
                                    <Button color="primary" className="mt-2 me-2" onClick={() => Navigate('/security-systems/' + securitySystemId + '/manufacturers/create')}>{t('securitySystems.manufacturers.list.addNew')}</Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                    {!isNull(manufacturerId) && 
                        <Col md="6">
                            <AddUpdateManufacturer getManufacturers={ () => getManufacturers({ security_system: {value: securitySystemId} }) } />
                        </Col>
                    }
                </Row>
                {(!isNull(manufacturerId) && manufacturerId !== 'create') &&
                    <Fragment>
                        <hr/>
                        <Systems />
                    </Fragment>
                }
            </Fragment>
        )
    }
}

export default Manufacturers